module.exports = __webpack_public_path__ + "static/coffee_talk-c8b6ba9429c211cc2f98a67ae9d691ec.png";